var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMCuisse2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 178,
    viewBox: "0 0 120 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.031 177C111.843 133.562 110.003 77.5921 107.411 49.1571C104.818 20.7222 107.627 10.7618 107.627 6.67572e-06",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.454 71.7056C117.454 71.7056 120.02 102.295 118.129 135.885",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2931 177C7.48108 133.562 9.32093 77.5921 11.9132 49.1571C14.5054 20.7222 11.6966 10.7618 11.6967 6.67572e-06",
    stroke: "#909090",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87036 71.7056C1.87036 71.7056 -0.695481 102.295 1.19478 135.885",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeDasharray: "3.97 3.97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCuisse2);
export default __webpack_public_path__ + "static/media/M-CUISSE_2.a817365acf9fec2c81b948ae348b86df.svg";
export { ForwardRef as ReactComponent };